import React, { useState, useMemo, useEffect, useRef } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import OliCard from './components/OliCard';
import Pagination from '../../components/ui/Pagination';
import CategoryFilter from './components/CategoryFilter';
import OliDetailModal from './components/OliDetailModal';
import SearchBar from './components/SearchBar';

const ITEMS_PER_PAGE = 20;



const OliAndAccessories = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedOli, setSelectedOli] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const catalogRef = useRef(null);

  React.useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, activeCategory]);

  useEffect(() => {
    if (!catalogRef.current) return;

    catalogRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [currentPage]);


  const categories = [
  { id: 'all', name: 'Semua Kategori', icon: 'Grid3x3', count: 48 },
  { id: 'engine', name: 'Mesin & Transmisi', icon: 'Cog', count: 12 },
  { id: 'body', name: 'Body & Rangka', icon: 'Box', count: 8 },
  { id: 'electrical', name: 'Kelistrikan', icon: 'Zap', count: 10 },
  { id: 'brake', name: 'Rem & Suspensi', icon: 'Disc', count: 6 },
  { id: 'accessories', name: 'Aksesoris', icon: 'Sparkles', count: 12 }];

  const oli = [
  {
    id: 1,
    name: "AHM Oil SPX2",
    category: "Oli",
    categoryId: "oil",

    description:
      "AHM Oil SPX2 adalah oli mesin resmi Honda untuk motor matic, diformulasikan untuk menjaga performa mesin, efisiensi bahan bakar, dan perlindungan optimal terhadap gesekan.",

    oliCode: "082342MBK0LZ0",
    price: 70500,

    // ===== LEGACY FIELD (SPAREPART MODE) =====
    // stock: 0,
    // additionalImages: [
    // additionalImages: [ { url: "https://img.rocket.new/generatedImages/rocket_gen_img_108306c29-1764661222349.png", alt: "Front view of brake pad showing friction surface" }, { url: "https://img.rocket.new/generatedImages/rocket_gen_img_16a41b94d-1766488080504.png", alt: "Side profile of brake pad showing thickness" }]

    image: "/assets/oli/AHMOilSPX2–0.8L.webp",
    imageAlt: "AHM Oil SPX2 10W-30 0.8 Liter Oli Mesin Motor Matic Honda",

    isGenuine: true,
    isNew: true,
    warranty: "—",

    compatibleModels: [
      "Beat",
      "Beat Street",
      "Scoopy",
      "Vario 110",
      "Vario 125",
      "Genio"
    ],

    specifications: [
      { label: "Jenis Oli", value: "Oli Mesin Matic" },
      { label: "SAE", value: "10W-30" },
      { label: "API", value: "SJ" },
      { label: "JASO", value: "MB" },
      { label: "Volume", value: "0.8 Liter" }
    ]
  },
  {
    id: 2,
    name: "Oli Gardan Transmission Gear Oil (Fully Synthetic)",
    category: "Oli",
    categoryId: "oil",
    description:
      "Oli gardan Honda dengan formulasi fully synthetic untuk menjaga kehalusan transmisi CVT dan mengurangi keausan gear.",
    oliCode: "0829399990",
    price: 19500,
    image: "/assets/oli/OliGardanTransmissionGearOil(Fully Synthetic).webp",
    imageAlt: "Oli Gardan Honda Fully Synthetic",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    compatibleModels: ["Beat", "Scoopy", "Vario", "PCX", "ADV"],
    specifications: [
      { label: "Jenis", value: "Oli Gardan CVT" },
      { label: "Tipe", value: "Fully Synthetic" },
      { label: "Volume", value: "120 ml" }
    ]
  },
{
  id: 3,
  name: "AHM Oil MPX2 0.8L",
  category: "Oli",
  categoryId: "oil",
  description:
    "AHM Oil MPX2 adalah oli mesin untuk motor bebek dan sport Honda dengan performa stabil dan perlindungan mesin optimal.",
  oliCode: "08232MPX20L",
  price: 59000,
  image: "/assets/oli/AHMOilMPX2–0.8L10W-30.webp",
  imageAlt: "AHM Oil MPX2 10W-30 0.8 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Supra X 125", "Revo", "Blade", "CB150R"],
  specifications: [
    { label: "Jenis Oli", value: "Oli Mesin Bebek / Sport" },
    { label: "SAE", value: "10W-30" },
    { label: "API", value: "SL" },
    { label: "JASO", value: "MA" },
    { label: "Volume", value: "0.8 Liter" }
  ]
},
{
  id: 4,
  name: "Oil Shock Depan 10W Honda",
  category: "Oli",
  categoryId: "oil",
  description:
    "Oli shock depan Honda SAE 10W untuk menjaga redaman suspensi depan tetap stabil dan nyaman.",
  oliCode: "0820899990",
  price: 29500,
  image: "/assets/oli/OilShockDepan(10 W)MotorHonda.webp",
  imageAlt: "Oli Shock Depan Honda SAE 10W",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Semua Motor Honda"],
  specifications: [
    { label: "Jenis", value: "Oli Shock Depan" },
    { label: "SAE", value: "10W" }
  ]
},
{
  id: 5,
  name: "Oli Gardan Transmission Gear Oil",
  category: "Oli",
  categoryId: "oil",
  description:
    "Oli gardan Honda untuk menjaga kinerja transmisi CVT tetap halus dan awet.",
  oliCode: "0829399991",
  price: 16500,
  image: "/assets/oli/OliGardan–TransmissionGearOil.webp",
  imageAlt: "Oli Gardan Honda",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Beat", "Scoopy", "Vario"],
  specifications: [
    { label: "Jenis", value: "Oli Gardan CVT" },
    { label: "Volume", value: "120 ml" }
  ]
},
{
  id: 6,
  name: "AHM Oil SPX2 0.65L",
  category: "Oli",
  categoryId: "oil",
  description:
    "Oli mesin fully synthetic Honda untuk motor matic kapasitas kecil.",
  oliCode: "082342MBK65",
  price: 61500,
  image: "/assets/oli/AHMOilSPX2–0.65L10W-30.webp",
  imageAlt: "AHM Oil SPX2 0.65 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Beat", "Scoopy", "Genio"],
  specifications: [
    { label: "SAE", value: "10W-30" },
    { label: "JASO", value: "MB" },
    { label: "Volume", value: "0.65 Liter" }
  ]
},
{
  id: 7,
  name: "Grease CVT Honda 10 Gram",
  category: "Pelumas",
  categoryId: "Pelumas",
  description:
    "Gemuk CVT Honda untuk melumasi komponen CVT agar tetap halus dan tahan aus.",
  oliCode: "0879899990",
  price: 15000,
  image: "/assets/oli/Grease,GemukCVT10Gram.webp",
  imageAlt: "Grease CVT Honda 10 Gram",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Beat", "Scoopy", "Vario", "PCX"],
  specifications: [
    { label: "Jenis", value: "Grease CVT" },
    { label: "Berat", value: "10 Gram" }
  ]
},
{
  id: 8,
  name: "Cairan Pendingin Radiator Honda",
  category: "Pelumas",
  categoryId: "Pelumas",
  description:
    "Coolant Honda untuk menjaga suhu mesin tetap stabil dan mencegah korosi.",
  oliCode: "0823199990",
  price: 19500,
  image: "/assets/oli/CairanPendingin(Coolant)–AirRadiator.webp",
  imageAlt: "Coolant Radiator Honda",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Berpendingin Cairan"],
  specifications: [
    { label: "Jenis", value: "Coolant Radiator" },
    { label: "Volume", value: "240 ml" }
  ]
},
{
  id: 9,
  name: "Minyak Rem Honda DOT 3",
  category: "Pelumas",
  categoryId: "Pelumas",
  description:
    "Minyak rem Honda DOT 3 untuk sistem pengereman hidrolik.",
  oliCode: "0820399990",
  price: 8500,
  image: "/assets/oli/MinyakRem(BrakeFluidHBF50ML)–MegaPro,SupraX125 Tiger.webp",
  imageAlt: "Minyak Rem Honda DOT 3",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Mega Pro", "Supra X 125", "Tiger"],
  specifications: [
    { label: "Jenis", value: "Brake Fluid" },
    { label: "DOT", value: "DOT 3" }
  ]
},
{
  id: 10,
  name: "AHM Oil MPX2 0.65L",
  category: "Oli",
  categoryId: "oil",
  description:
    "Oli mesin Honda untuk motor bebek dengan kapasitas mesin kecil.",
  oliCode: "08232MPX265",
  price: 50000,
  image: "/assets/oli/AHMOilMPX2–0.65L10W-30.webp",
  imageAlt: "AHM Oil MPX2 0.65 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Supra", "Revo"],
  specifications: [
    { label: "SAE", value: "10W-30" },
    { label: "JASO", value: "MA" },
    { label: "Volume", value: "0.65 Liter" }
  ]
},
{
  id: 11,
  name: "AHM Oil SPX1 1.2L",
  category: "Oli",
  categoryId: "oil",
  description:
    "AHM Oil SPX1 adalah oli mesin semi synthetic Honda untuk motor sport dan bebek, memberikan perlindungan mesin dan kestabilan performa.",
  oliCode: "08234SPX11L",
  price: 90000,
  image: "/assets/oli/AHMOilSPX1–1.2L10W-30.webp",
  imageAlt: "AHM Oil SPX1 10W-30 1.2 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Bebek & Sport"],
  specifications: [
    { label: "SAE", value: "10W-30" },
    { label: "API", value: "SL" },
    { label: "JASO", value: "MA" },
    { label: "Volume", value: "1.2 Liter" }
  ]
},
{
  id: 12,
  name: "AHM Oil SPX1 0.8L",
  category: "Oli",
  categoryId: "oil",
  description:
    "Oli mesin Honda SPX1 untuk motor sport dan bebek dengan spesifikasi semi synthetic.",
  oliCode: "08234SPX10L",
  price: 69500,
  image: "/assets/oli/AHMOilSPX1–0.8L10W-30.webp",
  imageAlt: "AHM Oil SPX1 10W-30 0.8 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Bebek & Sport"],
  specifications: [
    { label: "SAE", value: "10W-30" },
    { label: "API", value: "SL" },
    { label: "JASO", value: "MA" },
    { label: "Volume", value: "0.8 Liter" }
  ]
},
{
  id: 13,
  name: "AHM Oil MPX1 0.8L",
  category: "Oli",
  categoryId: "oil",
  description:
    "AHM Oil MPX1 adalah oli mesin mineral Honda untuk motor bebek dengan penggunaan harian.",
  oliCode: "08232MPX10L",
  price: 57000,
  image: "/assets/oli/AHMOilMPX1–0.8L10W-30.webp",
  imageAlt: "AHM Oil MPX1 10W-30 0.8 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Bebek"],
  specifications: [
    { label: "SAE", value: "10W-30" },
    { label: "API", value: "SJ" },
    { label: "JASO", value: "MA" },
    { label: "Volume", value: "0.8 Liter" }
  ]
},
{
  id: 14,
  name: "Throttle Body Cleaner 500ml",
  category: "Chemical",
  categoryId: "Chemical",
  description:
    "Cairan pembersih throttle body Honda untuk membersihkan kotoran pada sistem injeksi.",
  oliCode: "0820899995",
  price: 35500,
  image: "/assets/oli/ThrottleBodyCleaner500ML.webp",
  imageAlt: "Throttle Body Cleaner Honda 500ml",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Injeksi"],
  specifications: [
    { label: "Jenis", value: "Throttle Body Cleaner" },
    { label: "Volume", value: "500 ml" }
  ]
},
{
  id: 15,
  name: "AHM Oil SPX1 1L",
  category: "Oli",
  categoryId: "oil",
  description:
    "Oli mesin Honda SPX1 dengan volume 1 liter untuk motor sport dan bebek.",
  oliCode: "08234SPX101",
  price: 77500,
  image: "/assets/oli/AHMOilSPX1–1L10W-30.webp",
  imageAlt: "AHM Oil SPX1 10W-30 1 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Bebek & Sport"],
  specifications: [
    { label: "SAE", value: "10W-30" },
    { label: "API", value: "SL" },
    { label: "JASO", value: "MA" },
    { label: "Volume", value: "1 Liter" }
  ]
},
{
  id: 16,
  name: "AHM Oil MPX1 1.2L",
  category: "Oli",
  categoryId: "oil",
  description:
    "Oli mesin mineral Honda MPX1 untuk motor bebek dengan kapasitas besar.",
  oliCode: "08232MPX112",
  price: 73500,
  image: "/assets/oli/AHMOilMPX1–1.2L10W-30.webp",
  imageAlt: "AHM Oil MPX1 10W-30 1.2 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Bebek"],
  specifications: [
    { label: "SAE", value: "10W-30" },
    { label: "API", value: "SJ" },
    { label: "JASO", value: "MA" },
    { label: "Volume", value: "1.2 Liter" }
  ]
},
{
  id: 17,
  name: "AHM Chain Lube 70ml",
  category: "Pelumas",
  categoryId: "Pelumas",
  description:
    "Pelumas rantai Honda untuk menjaga kelenturan dan ketahanan rantai.",
  oliCode: "ACL70ML",
  price: 21000,
  image: "/assets/oli/PelumasRantai(AhmChainLube70ML)–ACL70ML.webp",
  imageAlt: "AHM Chain Lube 70ml",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Berantai"],
  specifications: [
    { label: "Jenis", value: "Chain Lubricant" },
    { label: "Volume", value: "70 ml" }
  ]
},
{
  id: 18,
  name: "Oil System Cleaner 70ml",
  category: "Chemical",
  categoryId: "Chemical",
  description:
    "Cairan pembersih sistem oli Honda untuk menjaga kebersihan ruang mesin.",
  oliCode: "OSC70ML",
  price: 30000,
  image: "/assets/oli/OilSystemCleaner70ML.webp",
  imageAlt: "Oil System Cleaner Honda 70ml",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda"],
  specifications: [
    { label: "Jenis", value: "Oil System Cleaner" },
    { label: "Volume", value: "70 ml" }
  ]
},
{
  id: 19,
  name: "AHM Oil MPX3 0.8L",
  category: "Oli",
  categoryId: "oil",
  description:
    "AHM Oil MPX3 adalah oli mesin full synthetic Honda untuk motor matic performa tinggi.",
  oliCode: "08232MPX30L",
  price: 50500,
  image: "/assets/oli/AHMOilMPX3–0.8LNIP.webp",
  imageAlt: "AHM Oil MPX3 0.8 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Matic"],
  specifications: [
    { label: "SAE", value: "10W-30" },
    { label: "JASO", value: "MB" },
    { label: "Volume", value: "0.8 Liter" }
  ]
},
{
  id: 20,
  name: "AHM Oil MPX1 1L",
  category: "Oli",
  categoryId: "oil",
  description:
    "Oli mesin Honda MPX1 1 liter untuk motor bebek.",
  oliCode: "08232MPX101",
  price: 65500,
  image: "/assets/oli/AHMOilMPX1–1L10W-30IDE.webp",
  imageAlt: "AHM Oil MPX1 10W-30 1 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Bebek"],
  specifications: [
    { label: "SAE", value: "10W-30" },
    { label: "API", value: "SJ" },
    { label: "JASO", value: "MA" },
    { label: "Volume", value: "1 Liter" }
  ]
},
{
  id: 21,
  name: "Carbon Cleaner 200ml",
  category: "Chemical",
  categoryId: "Chemical",
  description:
    "Cairan pembersih karbon Honda untuk membersihkan ruang bakar.",
  oliCode: "CC200ML",
  price: 45500,
  image: "/assets/oli/CarbonCleaner200ML.webp",
  imageAlt: "Carbon Cleaner Honda 200ml",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda"],
  specifications: [
    { label: "Jenis", value: "Carbon Cleaner" },
    { label: "Volume", value: "200 ml" }
  ]
},
{
  id: 22,
  name: "AHM Oil MPX3 1L",
  category: "Oli",
  categoryId: "oil",
  description:
    "Oli mesin full synthetic Honda MPX3 untuk motor matic.",
  oliCode: "08232MPX301",
  price: 55500,
  image: "/assets/oli/AHMOilMPX3–1L.webp",
  imageAlt: "AHM Oil MPX3 1 Liter",
  isGenuine: true,
  isNew: true,
  warranty: "—",
  compatibleModels: ["Motor Honda Matic"],
  specifications: [
    { label: "SAE", value: "10W-30" },
    { label: "JASO", value: "MB" },
    { label: "Volume", value: "1 Liter" }
  ]
},


];


  const filteredOli = useMemo(() => {
    let result = oli;

    if (activeCategory !== 'all') {
      result = result.filter((o) => o.categoryId === activeCategory);
    }

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      result = result.filter((o) =>
        o.name.toLowerCase().includes(q) ||
        o.oliCode.toLowerCase().includes(q) ||
        o.category.toLowerCase().includes(q) ||
        o.description.toLowerCase().includes(q)
      );
    }

    return result;
  }, [activeCategory, searchQuery, oli]);

  const totalPages = Math.ceil(filteredOli.length / ITEMS_PER_PAGE);

  const paginatedOli = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredOli.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredOli, currentPage]);



  const handleConsult = (oli) => {
    const message = `Halo, saya tertarik dengan ${oli?.name} (${oli?.oliCode}). Apakah masih tersedia?`;
    window.open(`https://wa.me/6288293642972?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background">
        <section className="bg-gradient-to-br from-primary to-accent py-12 md:py-16 lg:py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">

              <div className="inline-flex items-center space-x-2 bg-primary-foreground/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
                <Icon name="Droplet" size={20} color="white" />
                <span className="text-sm font-heading font-semibold text-primary-foreground">
                  Genuine Honda Oil
                </span>
              </div>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-foreground mb-4">
                Oli Mesin Honda
              </h1>

              <p className="text-base md:text-lg text-white mb-8 max-w-2xl mx-auto">
                Jaga performa dan usia mesin motor Anda dengan oli mesin original Honda.
                Dirancang khusus sesuai standar pabrikan untuk perlindungan dan efisiensi maksimal.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">

                {/* BUTTON 1 — HITAM → PUTIH */}
                <Button
                  size="lg"
                  iconName="MessageCircle"
                  iconPosition="left"
                  onClick={() => window.open('https://wa.me/6288293642972', '_blank')}
                  className="bg-black text-white hover:bg-white hover:text-black transition-colors duration-300"
                >
                  Info & Pemesanan
                </Button>

                {/* BUTTON 2 — PUTIH → HITAM */}
                  <Button
                    size="lg"
                    iconName="PackageCheck"
                    iconPosition="left"
                    onClick={() =>
                      (window.location.href = "/produk/oli")
                    }
                    className="bg-white text-black border border-white hover:bg-black hover:text-white transition-colors duration-300"
                  >
                    Cek Ketersediaan
                  </Button>

              </div>
            </div>
          </div>
        </section>


        <section ref={catalogRef} className="py-8 md:py-12 lg:py-16">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
              <div className="lg:col-span-1 space-y-6">

                <CategoryFilter
                  activeCategory={activeCategory}
                  onCategoryChange={setActiveCategory} />


                <div className="bg-card rounded-lg p-4 md:p-6 shadow-card-hover">
                  <h3 className="text-lg font-heading font-bold text-foreground mb-4 flex items-center space-x-2">
                    <Icon name="Info" size={20} color="var(--color-primary)" />
                    <span>Informasi Penting</span>
                  </h3>
                  <div className="space-y-3 text-sm text-muted-foreground">
                    <div className="flex items-start space-x-2">
                      <Icon name="Shield" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <p>Semua Oli Honda Berdikari Pamulang Genuine Honda</p>
                    </div>
                    <div className="flex items-start space-x-2">
                      <Icon name="Truck" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <p>Pengiriman tersedia untuk area Tangerang Selatan</p>
                    </div>
                    <div className="flex items-start space-x-2">
                      <Icon name="CheckCircle" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <p>Pemasangan gratis untuk pembelian di Honda Berdikari</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2 space-y-6">
                <div className="bg-card rounded-lg p-4 md:p-6 shadow-card-hover">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                    <div>
                      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-2">
                        Katalog Produk
                      </h2>
                      <p className="text-sm text-muted-foreground">
                        Menampilkan {filteredOli?.length} dari {oli?.length} produk
                      </p>
                    </div>
                    
                  </div>

                  <SearchBar
                    value={searchQuery}
                    onChange={setSearchQuery}
                    onClear={() => setSearchQuery('')} />

                </div>

                {filteredOli?.length > 0 ?
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
                    {paginatedOli?.map((oli) =>
                  <OliCard
                    key={oli?.id}
                    oli={oli}
                    onConsult={handleConsult}
                    onViewDetails={setSelectedOli} />
                  )}
                </div> :

                

                <div className="bg-card rounded-lg p-8 md:p-12 text-center shadow-card-hover">
                    <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
                      <Icon name="Search" size={40} color="var(--color-muted-foreground)" />
                    </div>
                    <h3 className="text-xl font-heading font-bold text-foreground mb-2">
                      Tidak Ada Hasil
                    </h3>
                    <p className="text-muted-foreground mb-6">
                      Maaf, tidak ada produk yang sesuai dengan pencarian Anda.
                      Coba ubah kata kunci atau filter yang digunakan.
                    </p>
                    <Button
                    variant="outline"
                    size="default"
                    iconName="RotateCcw"
                    iconPosition="left"
                    onClick={() => {
                      setSearchQuery('');
                      setActiveCategory('all');
                      setCurrentPage(1);
                    }}
                    >
                    
                      Reset Semua Filter
                    </Button>
                  </div>

                  
                }

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />

              </div>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12 lg:py-16 bg-muted" data-aos="fade-up">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
                  Mengapa Pilih Oli Original Honda?
                </h2>
                <p className="text-muted-foreground">
                  Perlindungan optimal untuk performa mesin yang lebih halus dan tahan lama
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* CARD 1 */}
                <div className="bg-card rounded-lg p-6 text-center shadow-card-hover">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="Shield" size={32} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                    Perlindungan Mesin Maksimal
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Melindungi komponen mesin dari gesekan berlebih dan panas, menjaga performa tetap optimal.
                  </p>
                </div>

                {/* CARD 2 */}
                <div className="bg-card rounded-lg p-6 text-center shadow-card-hover">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="CheckCircle" size={32} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                    Kualitas Teruji Honda
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Diformulasikan khusus sesuai standar Honda untuk menjaga kebersihan dan keawetan mesin.
                  </p>
                </div>

                {/* CARD 3 */}
                <div className="bg-card rounded-lg p-6 text-center shadow-card-hover">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="Gauge" size={32} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                    Performa Lebih Halus
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Mesin terasa lebih responsif, suara lebih halus, dan nyaman digunakan untuk aktivitas harian.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
  className="py-8 md:py-12 lg:py-16"
  data-aos="zoom-in-up"
  data-aos-delay="150"
>
  <div className="container mx-auto px-4">
    <div className="bg-gradient-to-br from-primary to-accent rounded-lg p-6 md:p-8 lg:p-12 text-center">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-foreground mb-4">
          Butuh Bantuan Memilih Oli yang Tepat?
        </h2>

        <p className="text-base md:text-lg text-white mb-8">
          Konsultasikan kebutuhan motor Anda bersama tim kami untuk mendapatkan
          rekomendasi oli Honda yang sesuai dengan tipe mesin dan penggunaan harian.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          {/* BUTTON 1 — CHAT WHATSAPP */}
          <Button
            size="lg"
            iconName="MessageCircle"
            iconPosition="left"
            onClick={() =>
              window.open(
                "https://wa.me/6288293642972?text=" +
                  encodeURIComponent(
                    "Halo Admin 👋\n\n" +
                    "Saya ingin *konsultasi* terkait pemilihan oli Honda.\n" +
                    "Motor yang saya gunakan dan kebutuhan pemakaiannya ingin saya konsultasikan.\n\n" +
                    "Terima kasih 🙏"
                  ),
                "_blank"
              )
            }
            className="
              bg-black text-white
              hover:bg-white hover:text-black
              transition-all duration-300
              hover:scale-[1.03]
            "
          >
            Chat WhatsApp
          </Button>

          {/* BUTTON 2 — HUBUNGI KAMI (WHATSAPP) */}
          <Button
            size="lg"
            iconName="Phone"
            iconPosition="left"
            onClick={() =>
              window.open(
                "https://wa.me/6288293642972?text=" +
                  encodeURIComponent(
                    "Halo Admin 👋\n\n" +
                    "Saya tertarik dengan *oli original Honda*.\n" +
                    "Mohon info lebih lanjut terkait jenis oli, ketersediaan, dan rekomendasinya.\n\n" +
                    "Terima kasih 🙏"
                  ),
                "_blank"
              )
            }
            className="
              bg-white/90 text-black
              border border-white
              hover:bg-black hover:text-white
              transition-all duration-300
              hover:scale-[1.03]
            "
          >
            Hubungi Kami
          </Button>
        </div>
      </div>
    </div>
  </div>
</section>

      </main>
      <Footer />
      {selectedOli &&
      <OliDetailModal
        oli={selectedOli}
        onClose={() => setSelectedOli(null)}
        onConsult={handleConsult} />

      }
    </>);

};

export default OliAndAccessories;